<svg>
  <use
    [attr.xlink:href]="'assets/icons.svg#pinup-bots-logo'"
    [attr.href]="'assets/icons.svg#pinup-bots-logo'"
  >
  </use>
</svg>
